import { Box, Button, Card, Flex, Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import { IoEyeOutline as EyeIcon } from "react-icons/io5";
import { MdOutlineModeEditOutline as EditIcon } from "react-icons/md";
import { TopLink } from '..';
import { useState, useEffect } from 'react';
import { openAtom, modalAtom, notificationAtom, openNAtom } from '../../../../context';
import { useAtom } from 'jotai';
import ViewSetting from '../Modal/ViewSetting';
import { apiCall } from '../../../../utils/apiCall';
import apiCallFormData from '../../../../utils/apiFormDataCall';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ReactPaginate from 'react-paginate';
import styled from '@emotion/styled';
import { Editor } from '../../../../components';
import HTMLReactParser from 'html-react-parser';
import { Loader } from '../../../../customs';

type EmailDataType = {
  Id: number;
  Code: string;
  Body: string;
};

const EmailTemplate = () => {
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const [, set_open_notification] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);
  const queryClient = useQueryClient();

  const { isLoading, data: getAllEmailList } = useQuery(['email-template'], {
    queryFn: async () => await apiCall().get(`/exam/setup/exam/GetAllExamEmailTemplate`),
    select(data) {
      return data.data.Data;
    }
  });

  const [filter_data, set_filter_data] = useState<any>(getAllEmailList);
  const itemsPerPage = 15;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  // const handlePageClick = (event: any) => {
  //   const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
  //   setItemOffset(newOffset);
  // };

  useEffect(() => {
    set_filter_data(getAllEmailList);
  }, [getAllEmailList]);

  const openView = (email: EmailDataType) => {
    set_modal({
      header: 'View Email Template',
      content: <ViewType email={email} />
    });
    set_open(true);
  };

  const openEdit = (email: EmailDataType) => {
    set_modal({
      header: 'Edit Email Template',
      content: <EditType email={email} />
    });
    set_open(true);
  };

  return (
    <> 
      {isLoading?<Loader />:
    <Box>
      <TopLink />
      <Flex justify="space-between" align="center" mt="20px">
        <Heading m="0" fontSize="1.5rem" color="var(--dark-green-color)">Email Template Editor</Heading>
      </Flex>
      <Flex mt="25px" flexDir="column" gap="10px">
        <Heading m="0" fontSize="1rem">All Email Templates</Heading>
        <Text m="0" fontSize=".8rem">
          Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length ? filter_data?.length : endOffset} of {filter_data?.length}
        </Text>
      </Flex>
      <Grid templateColumns={['repeat(1,.8fr)','1fr']}  gap="20px" mt="20px">
        {getAllEmailList && getAllEmailList.length > 0 ? (
          getAllEmailList.map(({ Id, Code, Body }: EmailDataType) => (
            <Card key={Id} as={GridItem} p="20px" display="flex" gap="10px" justify="space-between" flexDir="row">
              <Flex flexDir="column" gap="3px">
                <Box m="0">{HTMLReactParser(Code)}</Box>
              </Flex>
              <Flex alignSelf="center" gap="10px" align="center" fontSize="1.2rem">
                <EyeIcon
                  onClick={() => openView({ Id, Body, Code })}
                  style={{ cursor: 'pointer' }}
                />
                <EditIcon
                  onClick={() => openEdit({ Id, Body, Code })}
                  style={{ cursor: 'pointer' }}
                />
              </Flex>
            </Card>
          ))
        ) : (
          <Text>No templates found.</Text>
        )}
      </Grid>

      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />
      </StylePaginateBox>
    </Box>
   }
    </>

   
  );
};

const StylePaginateBox = styled.div`
  width: 100%;
  & > ul {
    list-style-type: none;
    text-align: center;
    padding: 0;
    margin: 0;
    margin-top: 10px;
  } 
  & > ul > li {
    display: inline;
    margin: 0 5px;
    padding: 2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color: var(--dark-green-color);
  }
  & > ul > li.selected {
    background-color: var(--highlight-paginate-background);
    color: var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type {
    font-weight: bold;
  }
`;

const ViewType = ({ email }: { email: EmailDataType }) => {
  return (
    <ViewSetting>
      <Flex width="100%" flexDir='column' as={GridItem}>
       {HTMLReactParser(email?.Code || '')}
        <Box>{HTMLReactParser(email?.Body || '')}</Box>  {/* Render Body content as HTML if necessary */}
      </Flex>
    </ViewSetting>
  );
};

const EditType = ({ email }: { email: EmailDataType }) => {
  const [value, set_value] = useState(email?.Body || ''); 
  const queryClient = useQueryClient();
  const [, set_open] = useAtom(openAtom);
  const [, set_notification] = useAtom(notificationAtom);
  const [, set_open_notification] = useAtom(openNAtom);

  const { mutate: editTemplate, isLoading } = useMutation({
    mutationFn: async (data: FormData) => {
      return await apiCallFormData().post(`/exam/setup/exam/CreateUpdateExamEmailTemplate`, data)
    },
    onSuccess: (data:any) => {
      console.log(data,'data success')
      set_notification({
        type: 'success',
        message: data?.data?.Message || 'Template updated successfully',
      });
      queryClient.invalidateQueries(['email-template']);
      set_open(false);
      set_open_notification(true);
    },
    onError: (error: any) => {
      set_notification({
        type: 'error',
        message: error?.response?.data?.Message || 'Error Occurred',
      });
      set_open(false);
      set_open_notification(true);
    },
    onSettled: () => {
      set_open(false);
    },
  });

  const handleSubmit = () => {
    if (value && email.Code) {      const formData = new FormData();
      formData.append('Id', email.Id.toString()); 
      formData.append('Code', email.Code);        
      formData.append('Body', value);             
      // console.log('FormData',formData)
      // console.log('code',email.Code)
      // console.log('body',value)
      // console.log('Id',email.Id)
      // console.log('FormData',formData)

      editTemplate(formData);
    } else {
      set_notification({
        type: 'error',
        message: 'Code and Body fields cannot be empty',
      });
    }
  };

  return (
    <Flex flexDir="column" gap="10px">
      <Editor value={value} onChange={set_value} />
      <Flex>
        <Button
          onClick={handleSubmit}
          bg="var(--dark-green-color)"
          color="var(--white-color)"
          disabled={isLoading}
        >
          {isLoading ? 'Loading ...' : 'Submit'}
        </Button>
      </Flex>
    </Flex>
  );
};



export default EmailTemplate;
